import {
  DropdownFieldParam,
  DropdownFieldValue,
  FieldData,
  FieldParam,
  FieldParamValue,
} from './types';
import { FieldKeyToField } from './fieldsData';
import useClasses from '../utils/useClasses';
import { IconButton, useTheme } from '@mui/material';
import CreateIcon from '@mui/icons-material/Create';
import { StrategyMode } from '../utils/strategy-data';

// Style const

interface Props {
  fieldData: FieldData;
  mode: string;
  onEdit: () => void;
  onRemove: () => void;
  isValid?: {
    status: boolean;
    errorIndex: number;
  };
  fieldIndex: number;
  isMathValid?: {
    status: boolean;
    mathErrorIndex: number;
  };
}
type AccumulatorType = {
  [key: string]: string | number | boolean;
};

export function CloseField(props: Props) {
  const { fieldData, mode, onEdit, isValid, fieldIndex, isMathValid } = props;
  const theme = useTheme();
  const styles = () => ({
    container: {
      height: '44px',
      margin: '0px 3px',
      display: 'flex',
      alignItems: 'center',
      borderRadius: '8px',
      padding: '4px 0px',
      background: theme.palette.info.light,
    },
    indicatorInfo: {
      margin: '0px 12px',
      width: 'max-content',
    },
    indicatorName: {
      fontSize: '14px',
      color: theme.component.equityBuilder.blueText,
      letterSpacing: '0.15px',
      lineHeight: '143%',
    },
    indicatorData: {
      fontSize: '12px',
      letterSpacing: '0.15px',
      lineHeight: '130%',
      color: theme.component.equityBuilder.indicatortext,
    },
    icon: {
      width: '4px',
      height: '16px',
      color: theme.component.equityBuilder.blueText,
      marginRight: '6px',
    },
    invalid: {
      border: `1px dashed ${theme.palette.error.main} !important`,
    },
  });
  const getResolutionValue = (indicatorParams: FieldParam[]): DropdownFieldValue[] => {
    const temp = indicatorParams
      .filter(param => param && param.key === 'resolution' && param.type === 'dropdown')
      .map(param => (param as DropdownFieldParam).values || []);
    return temp[0] || [];
  };

  const classes = useClasses(styles);
  const { key, params: paramsData } = fieldData;
  const indicator = FieldKeyToField()[key];
  const offset = paramsData.offset as FieldParamValue;
  const { params: indicatorParams } = indicator;
  const resolutionValue: DropdownFieldValue[] | undefined =
    getResolutionValue(indicatorParams);
  const paramValuesByKeys = resolutionValue?.reduce(
    (accumulator: AccumulatorType, value: DropdownFieldValue) => {
      accumulator[value.key] = value.value;
      return accumulator;
    },
    {} as AccumulatorType,
  );
  const resolution =
    paramValuesByKeys &&
    paramValuesByKeys[paramsData['resolution'] as FieldParamValue];

  return (
    <div
      className={`${classes.container} ${
        (isValid && isValid.status && isValid.errorIndex < fieldIndex) ||
        (isMathValid &&
          !isMathValid.status &&
          isMathValid.mathErrorIndex < fieldIndex)
          ? classes.invalid
          : ''
      }`}
    >
      <div className={classes.indicatorInfo}>
        <div className={classes.indicatorName}>{indicator.name}</div>
        <div className={classes.indicatorData}>
          ({offset}, {resolution})
        </div>
      </div>
      {mode === StrategyMode.EDIT ? (
        <IconButton id="menu" onClick={onEdit} className={classes.icon}>
          <CreateIcon fontSize={'small'} />
        </IconButton>
      ) : (
        <></>
      )}
    </div>
  );
}

export function NumberField(props: Props) {
  const { fieldData, mode, onEdit, isValid, fieldIndex, isMathValid } = props;
  const theme = useTheme();
  const styles = () => ({
    container: {
      height: '44px',
      margin: '0px 3px',
      display: 'flex',
      alignItems: 'center',
      borderRadius: '8px',
      padding: '4px 0px',
      background: theme.palette.info.light,
    },
    indicatorInfo: {
      margin: '0px 12px',
      width: 'max-content',
    },
    indicatorName: {
      fontSize: '14px',
      color: theme.component.equityBuilder.blueText,
      letterSpacing: '0.15px',
      lineHeight: '143%',
    },
    indicatorData: {
      fontSize: '12px',
      letterSpacing: '0.15px',
      lineHeight: '130%',
      color: theme.component.equityBuilder.indicatortext,
    },
    icon: {
      width: '4px',
      height: '16px',
      color: theme.component.equityBuilder.blueText,
      marginRight: '6px',
    },
    invalid: {
      border: `1px dashed ${theme.palette.error.main} !important`,
    },
  });
  const classes = useClasses(styles);
  const { key, params: paramsData } = fieldData;
  const indicator = FieldKeyToField()[key];
  const offset = paramsData.value;
  return (
    <div
      className={`${classes.container} ${
        (isValid && isValid.status && isValid.errorIndex < fieldIndex) ||
        (isMathValid &&
          !isMathValid.status &&
          isMathValid.mathErrorIndex < fieldIndex)
          ? classes.invalid
          : ''
      }`}
    >
      <div className={classes.indicatorInfo}>
        <div className={classes.indicatorName}>{indicator.name}</div>
        <div className={classes.indicatorData}>({offset})</div>
      </div>
      {mode === StrategyMode.EDIT ? (
        <IconButton id="menu" onClick={onEdit} className={classes.icon}>
          <CreateIcon fontSize={'small'} />
        </IconButton>
      ) : (
        <></>
      )}
    </div>
  );
}
